import Cookies from "js-cookie";

// Le conteneur GTM et la valeur par défaut du Consent Mode v2 (denied) sont
// imprimés en PHP via wp_head (cf. analytics-settings.php). Ce module gère
// uniquement les mises à jour de consentement et l'UI de la cookie bar.

const defaultCookieConsent = {
	ad_storage: false,
	ad_user_data: false,
	ad_personalization: false,
	analytics_storage: false,
};

window.dataLayer = window.dataLayer || [];
if (typeof window.gtag !== "function") {
	window.gtag = function () {
		window.dataLayer.push(arguments);
	};
}

const doNotTrack = navigator.doNotTrack || navigator.msDoNotTrack;

function maybeShowResult(elem) {
	const reponse = document.querySelector("section.mLegales div.reponse p");
	if (!reponse || !elem || !elem.dataset) return;

	const strong = document.createElement("strong");
	strong.textContent = elem.dataset.label + ": " + elem.dataset.status;
	reponse.replaceChildren(strong);
}

function readConsent() {
	const raw = Cookies.get("REQST_Consent");
	return raw ? JSON.parse(raw) : { ...defaultCookieConsent };
}

function writeConsent(consent) {
	Cookies.set("REQST_Consent", JSON.stringify(consent), { expires: 365 });
	Cookies.set("REQST_CookiesBarConsent", true, { expires: 365 });
}

function updateCookieConsent(variable, value) {
	const consent = readConsent();
	consent[variable] = value;
	writeConsent(consent);
	sendUpdateToGtag();
}

function updateAllCookieConsent(value) {
	const consent = readConsent();
	consent.ad_storage = value;
	consent.ad_user_data = value;
	consent.ad_personalization = value;
	consent.analytics_storage = value;
	writeConsent(consent);
	sendUpdateToGtag();
}

function sendUpdateToGtag() {
	const consent = readConsent();
	window.gtag("consent", "update", {
		ad_storage: consent.ad_storage ? "granted" : "denied",
		ad_user_data: consent.ad_user_data ? "granted" : "denied",
		ad_personalization: consent.ad_personalization ? "granted" : "denied",
		analytics_storage: consent.analytics_storage ? "granted" : "denied",
	});
}

export function startCookies() {
	if (
		doNotTrack === "yes" ||
		doNotTrack === "1" ||
		document.querySelector("#wpadminbar") !== null
	) {
		return false;
	}

	sendUpdateToGtag();
	return true;
}

function changeCookieConsent(elem, value = false) {
	let valid = false;
	let idTrack;

	if (typeof elem === "string") {
		idTrack = elem;
		valid = true;
	} else {
		const idDom = elem.getAttribute("id");
		const idSplit = idDom.split("-");

		if (idSplit.length >= 2) {
			idTrack = idSplit[0];
			valid = true;
			value = document.querySelector("input#" + idDom + ":checked").value;
			value = value.toLowerCase() === "true";
		}
	}

	if (valid) {
		switch (idTrack) {
			case "yes-to-all":
				updateAllCookieConsent(true);
				break;
			case "no-to-all":
				updateAllCookieConsent(false);
				break;
			case "ad_storage":
			case "ad_user_data":
			case "ad_personalization":
			case "analytics_storage":
				updateCookieConsent(idTrack, value);
				break;
			case "bandeauCookie": {
				const bandeau = document.querySelector("div.bandeauCookie");
				if (bandeau) {
					if (value === true) {
						changeCookieConsent("yes-to-all");
					} else if (value === false) {
						changeCookieConsent("no-to-all");
					}

					Cookies.set("REQST_CookiesBarConsent", true, { expires: 365 });
					bandeau.classList.remove("on");
					setTimeout(() => {
						document.querySelector("div.bandeauCookie")?.remove();
					}, 10000);
				}
				break;
			}
		}

		maybeShowResult(elem);
	}
}

if (typeof window !== "undefined") {
	window.REQST = window.REQST || {};
	window.REQST.cookies = {
		changeCookieConsent,
		updateCookieConsent,
		updateAllCookieConsent,
		sendUpdateToGtag,
		startCookies,
	};
}

export { changeCookieConsent, updateCookieConsent, updateAllCookieConsent, sendUpdateToGtag };

export function main() {
	// Mentions légales — radios consentement par catégorie
	if (document.querySelector("section.mLegales") !== null) {
		document
			.querySelectorAll("section.mLegales ul.mLegales button.moreInfos")
			.forEach((elem) => {
				elem.addEventListener("click", (event) => {
					event.preventDefault();
					document
						.querySelector("section.mLegales div.plusInfos#" + elem.getAttribute("id"))
						.classList.toggle("on");
				});
			});

		document
			.querySelectorAll("section.mLegales div.contenu input.buttonRadioConsent")
			.forEach((elem) => {
				elem.addEventListener("change", (event) => {
					event.preventDefault();
					changeCookieConsent(elem);
				});
			});
	}

	// Bandeau cookie hérité (ancien markup)
	const bandeau = document.querySelector("div.bandeauCookie");
	if (bandeau) {
		const cookieBarConsent = Cookies.get("REQST_CookiesBarConsent");

		if (cookieBarConsent !== null && cookieBarConsent !== true) {
			bandeau.querySelector("a.cookie-options")?.addEventListener("click", () => {
				changeCookieConsent("bandeauCookie", null);
			});
			bandeau.querySelector("button.cookie-accept")?.addEventListener("click", (event) => {
				event.preventDefault();
				changeCookieConsent("bandeauCookie", true);
			});
			bandeau.querySelector("button.cookie-decline")?.addEventListener("click", (event) => {
				event.preventDefault();
				changeCookieConsent("bandeauCookie", false);
			});
		} else {
			bandeau.remove();
		}
	}

	startCookies();
}
